import { TEXTURE_KEYS } from './assetKeys';
import { AUDIO_KEYS } from './audioKeys';

/** Path relatif dari index.html (Vite public/) */
export const EXTERNAL_AUDIO = {
  ambient: 'assets/audio/seism-ambient.wav',
  sfx_ui_click: 'assets/audio/sfx_ui_click.wav',
  sfx_interact: 'assets/audio/sfx_interact.wav',
  sfx_collect: 'assets/audio/sfx_collect.wav',
  sfx_quest: 'assets/audio/sfx_quest.wav',
  sfx_dialogue: 'assets/audio/sfx_dialogue.wav',
  sfx_decision: 'assets/audio/sfx_decision.wav',
  sfx_error: 'assets/audio/sfx_error.wav',
  sfx_score_up: 'assets/audio/sfx_score_up.wav',
  sfx_transition: 'assets/audio/sfx_transition.wav',
  sfx_earthquake: 'assets/audio/sfx_earthquake.wav',
  sfx_earthquake_rumble: 'assets/audio/sfx_earthquake_rumble.wav',
} as const;

export const EXTERNAL_SFX_MANIFEST: { key: string; url: string }[] = [
  { key: AUDIO_KEYS.UI_CLICK, url: EXTERNAL_AUDIO.sfx_ui_click },
  { key: AUDIO_KEYS.INTERACT, url: EXTERNAL_AUDIO.sfx_interact },
  { key: AUDIO_KEYS.COLLECT, url: EXTERNAL_AUDIO.sfx_collect },
  { key: AUDIO_KEYS.QUEST, url: EXTERNAL_AUDIO.sfx_quest },
  { key: AUDIO_KEYS.DIALOGUE, url: EXTERNAL_AUDIO.sfx_dialogue },
  { key: AUDIO_KEYS.DECISION, url: EXTERNAL_AUDIO.sfx_decision },
  { key: AUDIO_KEYS.ERROR, url: EXTERNAL_AUDIO.sfx_error },
  { key: AUDIO_KEYS.SCORE_UP, url: EXTERNAL_AUDIO.sfx_score_up },
  { key: AUDIO_KEYS.TRANSITION, url: EXTERNAL_AUDIO.sfx_transition },
  { key: AUDIO_KEYS.EARTHQUAKE, url: EXTERNAL_AUDIO.sfx_earthquake },
  { key: AUDIO_KEYS.EARTHQUAKE_RUMBLE, url: EXTERNAL_AUDIO.sfx_earthquake_rumble },
];

export { AUDIO_KEYS };

export const EXTERNAL_SPRITE_MANIFEST: { key: string; url: string }[] = [
  { key: TEXTURE_KEYS.PLAYER_IDLE_0, url: 'assets/sprites/player_idle_0.png' },
  { key: TEXTURE_KEYS.PLAYER_IDLE_1, url: 'assets/sprites/player_idle_1.png' },
  { key: TEXTURE_KEYS.PLAYER_WALK_0, url: 'assets/sprites/player_walk_0.png' },
  { key: TEXTURE_KEYS.PLAYER_WALK_1, url: 'assets/sprites/player_walk_1.png' },
  { key: TEXTURE_KEYS.PLAYER_WALK_2, url: 'assets/sprites/player_walk_2.png' },
  { key: TEXTURE_KEYS.PLAYER_WALK_3, url: 'assets/sprites/player_walk_3.png' },
  { key: TEXTURE_KEYS.KAKEK_SAKTI, url: 'assets/sprites/npc_kakek_sakti.png' },
  { key: TEXTURE_KEYS.IBUNDO, url: 'assets/sprites/npc_ibundo.png' },
  { key: TEXTURE_KEYS.LANSIA, url: 'assets/sprites/npc_lansia.png' },
  { key: TEXTURE_KEYS.IBU_HAMIL, url: 'assets/sprites/npc_ibu_hamil.png' },
  { key: TEXTURE_KEYS.WARGA, url: 'assets/sprites/npc_warga.png' },
  { key: TEXTURE_KEYS.PETUGAS, url: 'assets/sprites/npc_petugas.png' },
  { key: TEXTURE_KEYS.KERA, url: 'assets/sprites/npc_kera.png' },
  { key: TEXTURE_KEYS.HARIMAU, url: 'assets/sprites/npc_harimau.png' },
  { key: TEXTURE_KEYS.TREE_LARGE, url: 'assets/sprites/env_tree_large.png' },
  { key: TEXTURE_KEYS.TREE_FALLEN, url: 'assets/sprites/env_tree_fallen.png' },
  { key: TEXTURE_KEYS.GROUND_CRACK, url: 'assets/sprites/env_ground_crack.png' },
  { key: TEXTURE_KEYS.RAFFLESIA, url: 'assets/sprites/env_rafflesia.png' },
  { key: TEXTURE_KEYS.KERIS_1, url: 'assets/sprites/env_keris_1.png' },
  { key: TEXTURE_KEYS.KERIS_2, url: 'assets/sprites/env_keris_2.png' },
  { key: TEXTURE_KEYS.KERIS_3, url: 'assets/sprites/env_keris_3.png' },
  { key: TEXTURE_KEYS.HOUSE_BUBUNGAN, url: 'assets/sprites/env_house_bubungan.png' },
  { key: TEXTURE_KEYS.SIGN_BOARD, url: 'assets/sprites/env_sign_board.png' },
  { key: TEXTURE_KEYS.PATH_RIVER, url: 'assets/sprites/env_path_river.png' },
  { key: TEXTURE_KEYS.PATH_HILL, url: 'assets/sprites/env_path_hill.png' },
  { key: TEXTURE_KEYS.SAFE_GATHERING, url: 'assets/sprites/env_safe_gathering.png' },
  { key: TEXTURE_KEYS.BG_MENU, url: 'assets/sprites/bg_menu.png' },
  { key: TEXTURE_KEYS.BG_ZONE1, url: 'assets/sprites/bg_zone1.png' },
  { key: TEXTURE_KEYS.BG_ZONE2, url: 'assets/sprites/bg_zone2.png' },
  { key: TEXTURE_KEYS.BG_ZONE3, url: 'assets/sprites/bg_zone3.png' },
  { key: TEXTURE_KEYS.BG_ZONE4, url: 'assets/sprites/bg_zone4.png' },
  { key: TEXTURE_KEYS.BG_ZONE5, url: 'assets/sprites/bg_zone5.png' },
  { key: TEXTURE_KEYS.BG_ENDING, url: 'assets/sprites/bg_ending.png' },
  { key: TEXTURE_KEYS.UI_BUTTON, url: 'assets/sprites/ui_button.png' },
  { key: TEXTURE_KEYS.UI_DIALOGUE, url: 'assets/sprites/ui_dialogue.png' },
  { key: TEXTURE_KEYS.UI_QUEST, url: 'assets/sprites/ui_quest_panel.png' },
  { key: TEXTURE_KEYS.ICON_RAFFLESIA, url: 'assets/sprites/ui_icon_rafflesia.png' },
];
